import { render } from "./ParticipantHeader.vue?vue&type=template&id=79feb86c&ts=true"
import script from "./ParticipantHeader.vue?vue&type=script&lang=ts"
export * from "./ParticipantHeader.vue?vue&type=script&lang=ts"

import "./ParticipantHeader.vue?vue&type=style&index=0&id=79feb86c&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__